module.exports = __webpack_public_path__ + "img/DNA-SIS.e84638f1.svg";